import React, { Component } from 'react';
import '../App.css';
import Logo from '../components/widgets/Logo';
import MobileFooter from '../components/widgets/MobileFooter';

class NotFoundPage extends Component {
  render() {
    return (
      <React.Fragment>
        <Logo />
        <h1 className="not-found-page" >
          We're sorry, that page doesn't seem to exist!
        </h1>
        <div style={{ width: 300, margin: '72px auto 72px', textAlign: 'center' }}>
          <a href="/public">
          <button
            className="login-btn button-oval button-signin24 button-brand24 inflo24-gradient"
            onClick={() => {
              <Redirect to="/" />
            }}
          >
            Back to Home Page
          </button>
          </a>
        </div>
        <MobileFooter />
      </React.Fragment>
    );
  }
}

export default NotFoundPage;
